import { render, staticRenderFns } from "./ServiceOrderProductSelection.vue?vue&type=template&id=4b35777f&scoped=true&"
import script from "./ServiceOrderProductSelection.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderProductSelection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderProductSelection.vue?vue&type=style&index=0&id=4b35777f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35777f",
  null
  
)

export default component.exports